import { Segmentacao } from './segmentacao-ocultar-menu-avaliacoes.types';

const segmentacoes: Array<Segmentacao> = [
  {
    marcas: ['estacio', 'wyden'],
    periodo: '2025.4',
    modalidades: ['EAD', 'FLEX'],
  },
];

export const segmentacaoOcultarMenuAvaliacoesConfig: Array<Segmentacao> = segmentacoes;
